import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar, Line } from "react-chartjs-2";
import { format } from "date-fns";
import { jsonParse } from "../utilFunctions";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const getDateList = (gisSurveyData, type) => {
  let datesList = [];
  if (type === "imd_rainfall" && gisSurveyData?.jsonResponse?.Rainfall_dates) {
    datesList = jsonParse(gisSurveyData?.jsonResponse?.Rainfall_dates);
  } else {
    datesList =
      gisSurveyData != null &&
      gisSurveyData?.jsonResponse?.dates &&
      jsonParse(gisSurveyData?.jsonResponse?.dates);
  }
  return datesList;
};
const getDataSetList = (gisSurveyData, type) => {
  const dataListAll = [
    {
      label: "MSAVI",
      data: jsonParse(gisSurveyData?.jsonResponse?.MSAVI),
      borderColor: "rgb(255, 165, 0)",
      backgroundColor: "rgba(255, 165, 0, 0.2)",
      yAxisID: "y",
    },
    {
      label: "NDMI",
      data: jsonParse(gisSurveyData?.jsonResponse?.NDMI),
      borderColor: "rgb(0, 200, 0)",
      backgroundColor: "rgba(0, 200, 0, 0.2)",
      yAxisID: "y",
    },
    {
      label: "NDVI",
      data: jsonParse(gisSurveyData?.jsonResponse.NDVI),
      borderColor: "rgb(255, 255, 0)",
      backgroundColor: "rgba(255, 255, 0, 0.2)",
      yAxisID: "y",
    },
  ];
  const dataListImdRainfall = [
    {
      label: "IMD Rainfall",
      data: jsonParse(gisSurveyData?.jsonResponse.Rainfall),
      borderColor: "blue",
      backgroundColor: "blue",
      yAxisID: "y",
    },
  ];
  if (type === "imd_rainfall") {
    return dataListImdRainfall;
  } else {
    return dataListAll;
  }
};
export default function GisSurveyChart({ gisSurveyData, gisReportName, type }) {
  const [chartConfig, setChartConfig] = useState(null);

  const prepareChartConfig = () => {
    const datesList = getDateList(gisSurveyData, type);
    const dataListAll = getDataSetList(gisSurveyData, type);
    const labels = datesList?.length
      ? datesList.map((list) => format(new Date(list), "dd-MM-yyyy"))
      : [];

    let data;
    if (gisReportName === "all" || gisReportName === "imd_rainfall") {
      data = {
        labels,
        datasets: dataListAll,
      };
    } else {
      data = {
        labels,
        datasets: dataListAll.filter((list) =>
          list.label.includes(gisReportName?.toUpperCase())
        ),
      };
    }

    const options = {
      animation: false,
      responsive: true,
      interaction: {
        mode: "index",
        intersect: false,
      },
      stacked: false,
      plugins: {
        title: {
          display: false,
        },
        legend: {
          display: true,
          position: "top",
          labels: {
            font: {
              size: 12,
            },
            usePointStyle: type === "imd_rainfall" ? false : true,
            pointStyle: "line",
          },
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: "Dates",
          },
        },
        y: {
          type: "linear",
          display: true,
          position: "left",
          beginAtZero: true,
          title: {
            display: true,
            text: type === "imd_rainfall" ? "Rainfall(mm)" : "Values",
          },
        },
      },
    };
    return {
      data,
      options,
    };
  };

  useEffect(() => {
    if (gisSurveyData && gisReportName) {
      const config = prepareChartConfig(gisSurveyData, gisReportName);
      setChartConfig(config);
    }
  }, [gisSurveyData, gisReportName]);

  return (
    <>
      {type === "imd_rainfall" && chartConfig?.data.labels?.length && (
        <Bar
          id="imd_rainfall_chart"
          options={chartConfig.options}
          data={chartConfig.data}
        />
      )}
      {type !== "imd_rainfall" && chartConfig?.data.labels?.length && (
        <Line
          id="chart"
          options={chartConfig.options}
          data={chartConfig.data}
        />
      )}
    </>
  );
}
